import { axiosPrivate } from "@/api/axios";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

export interface ProductCategory {
  id: number;
  name: string;
}

export default function useProductCategories() {
  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["productCategories"],
    queryFn: async (): Promise<ProductCategory[]> => {
      const endpoints = ["/categories/"];
      let lastErr: any = null;
      for (const ep of endpoints) {
        try {
          const response = await axiosPrivate.get(ep);
          const raw = response.data;
          // Heuristic: accept if success true OR data is array
            const dataNode = Array.isArray(raw?.data)
              ? raw.data
              : Array.isArray(raw?.data?.results)
                ? raw.data.results
                : Array.isArray(raw?.results)
                  ? raw.results
                  : null;
            if (!dataNode) {
              // Try next endpoint
              lastErr = new Error(`Unexpected categories shape from ${ep}`);
              continue;
            }
            const mapped = dataNode.map((c: any) => ({
              id: Number(c.id ?? c.category_id),
              name: c.name ?? c.title ?? "Unnamed",
            }));
            // debug: endpoint ep fetched mapped.length categories
            return mapped.sort((a: ProductCategory, b: ProductCategory) => a.name.localeCompare(b.name));
        } catch (e: any) {
          lastErr = e;
          continue;
        }
      }
      toast.error("Failed to load product categories");
      throw lastErr || new Error("Could not fetch categories");
    },
    staleTime: 60_000,
    retry: 1,
  });

  return { data, isLoading, isFetching, isError, error, refetch };
}
